import {Directive, OnInit, ElementRef, Renderer2, Input} from "@angular/core";
@Directive({
    selector: '[resaltar]'
})

export class ResaltarDirective implements OnInit{
    // sobreescribir fn onInit
    @Input('resaltar')plan:string='';
    ngOnInit(){
        //obtener el elemento que tenemos el atributo basados en el plan
        if (this.plan=='pagado'){
            this.renderer.setStyle(this.elRef.nativeElement, 'background-color', '#fffaff');
            this.renderer.setStyle(this.elRef.nativeElement, 'font-weight', 'bold');
            this.renderer.setStyle(this.elRef.nativeElement, 'border', '2px solid rgb(79, 162, 116)');
        }
    }
    // contructor 
    constructor(private elRef: ElementRef, private renderer: Renderer2){

    }
}


// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/directives/resaltar.directive.ts